import { inject } from 'vue'

export const messagesKey = Symbol('messages')

export function useMessages() {
    const messages = inject(messagesKey, null)

    if (!messages) throw new Error('Messages service is not registered.')

    return messages
}
